<template>
   <div class="container">
    <div class="row">
      <h2>Requisições Disponíveis</h2>
      <hr>
      <div v-if="loading">
        <loader></loader>
      </div>
      <div v-else>
        <div class="col-md-3 sidebar">
          <div v-for="tag in tags" class="col-sm-6 col-xs-12 col-md-12">
              <div class="panel panel-default panel-heading clickable" @click="selectedTag = tag" :class="{'selected': tag === selectedTag }">
                  <div class="row">
                      <div class="col-xs-12 text-center">
                          <div><span class="huge">{{tag}}</span> <span class="badge pull-right">{{tagCount(tag)}}</span></div>
                          <div></div>
                         
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="col-md-9">
          <input class="form-control" v-model="filter" placeholder="Filtrar..."/>
          <br/>
          <div id="request-types-list" class="list-group" v-if="workflows.length > 0">
            <router-link :to="{name: 'RequestForm', params: {workflowId: workflow.objectId}}"
                v-for="workflow in filteredWorkflows" :key="workflow.objectId" class="list-group-item">
              <h4 class="list-group-item-heading">{{workflow.name}}</h4>
              <p class="list-group-item-text" v-if="workflow.reqType">{{workflow.reqType.name}}</p>
            </router-link>
          </div>
          <div class="alert alert-info" v-else>
              Não há fluxos cadastrados no sistema.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Parse
  } from '../Global'

  import Loader from './util/Loader'
  import { handleParseError } from './util/ErrorHandling'

  export default {
    components: {
      Loader
    },
    data () {
      return {
        workflows: [],
        loading: false,
        selectedTag: '',
        tagAll: 'Todas',
        filter: ''
      }
    },
    mounted () {
      this.getWorkflows()
      let tag = this.$route.params.tag
      if (tag) {
        this.selectedTag = tag
      } else {
        this.selectedTag = this.tagAll
      }
    },
    methods: {
      getWorkflows () {
        let self = this
        this.loading = true
        Parse.Cloud.run('listAvaliableWorkflows').then((results) => {
          self.workflowsParse = results
          self.workflows = results.map(r => r.toJSON())
          self.loading = false
        }, (error) => {
          self.loading = false
          handleParseError(self, error)
        })
      },
      tagCount (tag) {
        if (tag === this.tagAll) {
          return this.workflows.length
        } else {
          return this.workflows.filter(w => w.tags.includes(tag)).length
        }
      }
    },
    computed: {
      filteredWorkflows () {
        let self = this
        let filter = this.filter.toLowerCase()
        return this.workflows.filter(w => {
          return (w.tags.includes(self.selectedTag) || self.selectedTag === self.tagAll) && ((w.name && w.name.toLowerCase().indexOf(filter) > -1) ||
            (w.description && w.description.toLowerCase().indexOf(filter) > -1))
        })
      },
      tags () {
        let self = this
        let tags = {}
        self.workflows.forEach(w => {
          w.tags.forEach(t => {
            tags[t] = true
          })
        })
        return [self.tagAll].concat(Object.keys(tags))
      }
    }
  }

</script>

<style scoped lang="scss">
  $active:  #337ab7;
  .clickable {
    cursor: pointer;
    color: $active;
  }
  .selected {
    background: $active;
    color: white;
  }
  .sidebar {
    z-index: 999;
  }
  .selected .badge {
    background: white;
    color: $active;
  }
  .badge {
    margin-top: 2px;
  }
  .clickable:hover {
    @extend .selected;
    background: darken($active, 15%)
  }
  .huge {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// RequestOpen.vue?3adc7473